/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m2.27 11.14.52 1.23-1.36 1.78 2.3 2.32 1.88-1.27 1.25.54.48 2.26h3.32l.5-2.27 1.23-.53 1.95 1.23 2.2-2.25-1.35-1.83.51-1.21 2.27-.53V7.39l-2.27-.52-.52-1.22 1.37-1.77-2.26-2.38-1.89 1.27-1.25-.54-.5-2.27H7.36l-.5 2.26-1.27.54-1.92-1.23-2.24 2.3 1.36 1.78-.53 1.23L0 7.38v3.22Zm.68-3.44.94-2.19-1.2-1.57L3.81 2.8l1.68 1.08 2.19-.93.45-2h1.75l.45 2 2.18.95 1.65-1.12 1.15 1.17-1.2 1.55.94 2.19 2 .46v1.7l-2 .47-.92 2.15 1.17 1.61-1.11 1.12-1.72-1.08-2.15.93-.43 2H8.11l-.42-2-2.18-.94-1.66 1.13-1.15-1.17 1.19-1.57-.94-2.2-2-.43V8.16Zm6 5.44a4.13 4.13 0 1 0-4.13-4.13A4.14 4.14 0 0 0 9 13.14Zm0-7.25A3.11 3.11 0 1 1 5.84 9a3.11 3.11 0 0 1 3.11-3.11Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'GearIcon';

export default Icon;
